var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export var usersApi = createApi({
    reducerPath: 'usersApi',
    baseQuery: fetchBaseQuery({
        baseUrl: (window === null || window === void 0 ? void 0 : window.baseUrl) + "api/method/",
        credentials: 'include'
    }),
    tagTypes: ['User'],
    endpoints: function (builder) { return ({
        userState: builder.query({
            query: function (payload) { return ({
                url: payload.url,
                method: "GET",
            }); },
            providesTags: ['User']
        }),
        login: builder.mutation({
            query: function (payload) { return ({
                url: "login",
                method: 'POST',
                body: payload,
            }); },
            invalidatesTags: ['User'],
            transformResponse: function (response) {
                if (response.message === "Logged In")
                    return __assign(__assign({}, response), { isLoggedIn: true });
                else
                    return __assign(__assign({}, response), { isLoggedIn: false });
            }
        }),
        logout: builder.mutation({
            query: function (payload) { return ({
                url: "logout",
                method: 'GET'
            }); },
            invalidatesTags: ['User'],
            transformResponse: function (response) {
                if (response.message === "Logged In")
                    return __assign(__assign({}, response), { isLoggedIn: true });
                else
                    return __assign(__assign({}, response), { isLoggedIn: false });
            }
        })
    }); }
});
export var useUserStateQuery = usersApi.useUserStateQuery, useLoginMutation = usersApi.useLoginMutation, useLogoutMutation = usersApi.useLogoutMutation;
export default usersApi;
